<template>
  <div class="mt-2">
    <RequisitionList
      mode="closed"
      meta-name="Closed"
    />
  </div>
</template>

<script>
import { mapActions } from 'pinia';
import RequisitionList from '@/components/requisitions/RequisitionList.vue';
import { useAppBase } from '@/stores/app/base';

export default {
  name: 'ClosedReqList',
  components: {
    RequisitionList,
  },
  emits: ['track-page-load'],
  mounted() {
    this.showFilterBarSettings({ route: this.$route.name });
    this.$emit('track-page-load', { page: 'Requisitions: Closed' });
  },
  methods: {
    ...mapActions(useAppBase, ['showFilterBarSettings']),
  },
};
</script>
